export const environment = {
  production: true,
  apiHost: 'https://bbfd-dfb7atckdjapfdbt.z03.azurefd.net',
  apiHostStaging: 'https://baulogistik-staging.azurewebsites.net',
};
